import { render, staticRenderFns } from "./new-order-dialog.vue?vue&type=template&id=642f7d54&scoped=true&lang=pug&"
import script from "./new-order-dialog.vue?vue&type=script&lang=js&"
export * from "./new-order-dialog.vue?vue&type=script&lang=js&"
import style0 from "./new-order-dialog.vue?vue&type=style&index=0&id=642f7d54&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642f7d54",
  null
  
)

export default component.exports